import axios from 'axios';
import Router from 'next/router';
import { setSession } from './jwt';
import { setSession as CommanSetSession } from './commonJwt';
import { setSession as mobileSetSession } from './mobileJwt';
import { setSession as employeeSetSession } from './employeeJwt';
import { dispatch } from 'src/redux/store';
import { hideLoader } from 'src/redux/slices/blockingLoader';
const axiosInstance = axios.create({ baseURL: process.env.NEXT_PUBLIC_API_URL || '' });

axiosInstance.interceptors.response.use(
  async (response) => response,
  async (error) => {
    const { response } = error;

    if (response && [401].includes(response.status)) {
      await CommanSetSession(null);
      await setSession(null);
      await mobileSetSession(null);
      await employeeSetSession(null);
      const pathType = Router.router.asPath?.split('/')[1];
      if (response?.statusText === 'Unauthorized') {
        dispatch(hideLoader());
        Router.push(Router.router.asPath);
        // if (pathType === 'scan') {
        //   Router.push(Router.router.asPath);
        // } else {
        //   // window.location.href = '/auth/login';
        //   Router.push(Router.router.asPath);

        // }
      }
    }

    if (response && [403, 404, 500].includes(response.status)) {
      const title = response.data.title;
      const description = response.data.message;
      if (response.data.access == 'scan') {
        dispatch(hideLoader());
        Router.push({ pathname: '/scan/error', query: { title: title, description } });
      }
      // else {
      //   Router.push(
      //     { pathname: "/dashboard/error", query: { title: title, description } });
      // }
    }

    return Promise.reject(error);
  }
); 

axiosInstance.defaults.headers.common['request-from'] = "frontend"; //Support of "frontend" in header

export default axiosInstance;
